<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED } from "@/constants";
import { mapState } from "vuex";
import { PRODUCT_MODULE } from '@/state/modules/product'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { productMethods, lookupMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
// import ProductGrid from "@/views/pages/product/components/productGrid";
import ProductTableClassic from "@/views/pages/product/components/productTableClassic";
import ProductGridTable from "@/views/pages/product/components/productGridTable";

export default {
    page: {
        title: i18n.t("label.listingX", [i18n.t('module.product')]),
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'Product-update' && to.name != 'Product-create' && to.name != 'Product-detail' && to.name != 'Product-listing' && to.name != 'home') {
            sessionHelper.clearSearch(SESSION.PRODUCT_SEARCH)
        }
        next();
    },
    async created() {
        await this.validPermissions();
        await this.initSearchCriteria();
        await this.lookupBrand({ hasOptionAll: false });
    },
    components: { Layout, PageHeader, Multiselect, DatePicker, ProductGridTable, ProductTableClassic },
    data() {
        const times = ddlHelper.getShellLifeTime();
        return {
            title: i18n.t("label.listingX", [i18n.t('module.product')]),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.product"),
                    active: true,
                },
            ],
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            accountLockStatusDdl: ddlHelper.getAccountLockStatus(true),
            currentUser: sessionHelper.getUserEmail(),
            timeDdl: times,
            currentPage: 1,
            filter: "",
            enabled: false,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            pageOptions: [10, 25, 50, 100],
            filterOn: [],
            isLoading: true,
            permissions: sessionHelper.getPermissions(),
            createPermission: null,
            updatePermission: null,
            updateStatusPermission: null,
            readPermission: null,
            exportPermission: null,
            brandID: null,
            sortBy: "name",
            advancedFilterForm: {
                company: "",
                formulation: "",
                class: "",
                moa: "",
                status: "",
                purpose: "",
                productAI: "",
                productSource: "",
                productRecommendation: "",
                lrmp: "",
                referenceNumber: "",
                dorStart: "",
                dorEND: "",
                expiredDateStart: "",
                expiredDateEnd: "",
                dossierSubmissionDateStart: "",
                dossierSubmissionDateEnd: "",
                isRegisterCert: "",
                approvalDateStart: "",
                approvalDateEnd: "",
                shelfLifeTime: "",
                productLabel: "",
            },
            columns: [
                { key: "name", label: i18n.t("label.name"), },
                { key: "lrmp", label: i18n.t("label.lrmp"), },
                { key: "reference", label: i18n.t("label.XreferenceNumber", []), },
                { key: "dor", label: i18n.t("label.dor"), },
                { key: "expired", label: i18n.t("label.XexpiredDate", []), },
                { key: "remark", label: i18n.t("label.remark"), },
                { key: "submission", label: i18n.t("label.dorSubmissionDate"), },
                { key: "approval", label: i18n.t("label.approvalDate"), },
                { key: "registration", label: i18n.t("label.isRegisterCert"), },
                { key: "brand", label: i18n.t("module.brand"), },
                { key: "form", label: i18n.t("module.form"), },
                { key: "class", label: i18n.t("module.class"), },
                { key: "moa", label: i18n.t("module.moa"), },
                { key: "status", label: i18n.t("module.status"), },
                { key: "type", label: i18n.t("module.type"), },
                { key: "purpose", label: i18n.t("module.purpose"), },
                { key: "life", label: i18n.t("label.shelfLifeTime"), },
            ],
            fields: [
                { key: "name", sortable: true, label: i18n.t("label.name"), },
                { key: "lrmp", sortable: true, label: i18n.t("label.lrmp") },
                { key: "brand", sortable: true, label: i18n.t("module.company") },
                { key: "productAI", sortable: true, label: i18n.t("module.productAI") },
                { key: "status", sortable: true, label: i18n.t("module.status") },
                { key: "expiredDate", sortable: true, label: i18n.t("label.XexpiredDate", [i18n.t('module.product')]) },
                { key: "isActive", sortable: true, label: i18n.t("label.recordStatus") },
                { key: "Action", sortable: false, label: i18n.t("label.action"), },
            ],
            displayModeOptions: [
                { value: 1, text: i18n.t('label.list') },
                { value: 2, text: i18n.t('label.grid') },
                { value: 3, text: i18n.t('label.summary') },
            ],
            displayMode: { value: 1, text: i18n.t('label.grid') },
        };
    },
    computed: {
        ...mapState(PRODUCT_MODULE, ['status']),
        ...mapState(LOOKUP_MODULE),
        tableRows() {
            return this.$store.state.product.list.data;
        },
        pagination() {
            return this.$store.state.product.list.pagination;
        },
        totalPage() {
            return this.$store.state.product.list.pagination.total;
        },
        brandDdl() {
            return this.$store.state.lookup.brandDdl;
        },
    },
    mounted() { },
    validations: {
        filterOn: { required },
    },
    methods: {
        ...productMethods,
        ...lookupMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PRODUCT_PC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PRODUCT_PR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PRODUCT_PU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PRODUCT_PUS")) {
                this.updateStatusPermission = true;
            }
            else {
                this.updateStatusPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PRODUCT_PE")) {
                this.exportPermission = true;
            }
            else {
                this.exportPermission = false;
            }
        },
        async initSearchCriteria() {
            let isDefault = true;

            if (sessionHelper.hasSearchCriteria(SESSION.PRODUCT_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
                this.filter = this.searchCriteria.searchArray[0];
                this.isActive = ddlHelper.getActivationStatus(true).find(
                    item => item.value === this.searchCriteria.isActive
                );
                this.displayMode = this.searchCriteria.displayMode;

                // ✅ restore page size
                if (this.searchCriteria.pageSize) {
                    this.perPage = this.searchCriteria.pageSize;
                }
            }
            if (isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: this.perPage, // ✅ use perPage
                    isActive: this.statusDdl[1].value,
                    isLocked: this.accountLockStatusDdl[0].value,
                    searchValue: "",
                    searchArray: [],
                    displayMode: this.displayMode,
                };
            }

            if (this.readPermission == true) {
                this.searchCriteria.isFromHalex = 0;
                await this.getProductList(this.searchCriteria);
            }
        },

        onChangePerPage() {
            this.currentPage = 1;

            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.pageSize = this.perPage;

            this.getProductList(this.searchCriteria);
        },


        async getProductList(filter, isSaveFilter = true) {
            this.isLoading = true;
            filter.pageSize = this.perPage;
            await this.getAllProducts({ filter });
            this.searchCriteria = filter;
            if (isSaveFilter == true) {
                sessionHelper.storeSearch(SESSION.PRODUCT_SEARCH, filter);
            }
            this.isLoading = false;
        },

        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_SEARCH);
            filter.pageNumber = pageNumber;

            this.getProductList(filter);
        },

        filterBrand() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.brand = this.brandID.value;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.displayMode = this.displayMode;

            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getProductList(this.searchCriteria);
        },

        clearBrand() {
            this.brandID = null;
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.brand = this.brandID != null ? this.brandID.value : null;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.displayMode = this.displayMode;

            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getProductList(this.searchCriteria);
        },

        exportAll(isExportAll) {
            this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_SEARCH);
            this.searchCriteria.selectedColumns = this.filterOn;
            this.searchCriteria.isExportAll = isExportAll;
            var filter = this.searchCriteria;
            if (this.exportPermission == true) {
                this.exportProductList({ filter });
            }
        },

        exportFilterShowModal() {
            this.$bvModal.show('modal-filter');
        },

        advanceFilterShowModal() {
            this.$bvModal.show('modal-filter-advanced');
        },

        exportFilterCloseModal() {
            this.$bvModal.hide('modal-filter');
            this.filterOn = [];
        },

        advanceFilterCloseModal() {
            this.$bvModal.hide('modal-filter-advanced');
            // this.advancedFilterForm.company = "";
            // this.advancedFilterForm.formulation = "";
            // this.advancedFilterForm.class = "";
            // this.advancedFilterForm.moa = "";
            // this.advancedFilterForm.status = "";
            // this.advancedFilterForm.brand = "";
            // this.advancedFilterForm.purpose = "";
            // this.advancedFilterForm.productAI = "";
            // this.advancedFilterForm.productSource = "";
            // this.advancedFilterForm.productRecommendation = "";
            // this.advancedFilterForm.lrmp = "";
            // this.advancedFilterForm.referenceNumber = "";
            // this.advancedFilterForm.dorStart = "";
            // this.advancedFilterForm.dorEND = "";
            // this.advancedFilterForm.expiredDateStart = "";
            // this.advancedFilterForm.expiredDateEnd = "";
            // this.advancedFilterForm.dossierSubmissionDateStart = "";
            // this.advancedFilterForm.dossierSubmissionDateEnd = "";
            // this.advancedFilterForm.isRegisterCert = "";
            // this.advancedFilterForm.approvalDateStart = "";
            // this.advancedFilterForm.approvalDateEnd = "";
            // this.advancedFilterForm.shelfLifeTime = "";
        },

        exportFilter(isExportAll) {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_SEARCH);
                this.searchCriteria.selectedColumns = this.filterOn;
                this.searchCriteria.isExportAll = isExportAll;
                var filter = this.searchCriteria;
                if (this.exportPermission == true) {
                    this.exportProductList({ filter });
                }

                this.$bvModal.hide('modal-filter');
                this.filterOn = [];
            }
        },

        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.brand = this.brandID != null ? this.brandID.value : null;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            this.searchCriteria.displayMode = this.displayMode;

            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getProductList(this.searchCriteria);
        },

        advancedFilter() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.brand = this.advancedFilterForm.company != null ? this.advancedFilterForm.company : null;
            this.searchCriteria.shelfLifeTime = this.advancedFilterForm.shelfLifeTime == "" ? "" : this.advancedFilterForm.shelfLifeTime.code,
                this.searchCriteria.formulation = this.advancedFilterForm.formulation != null ? this.advancedFilterForm.formulation : null;
            this.searchCriteria.class = this.advancedFilterForm.class != null ? this.advancedFilterForm.class : null;
            this.searchCriteria.moa = this.advancedFilterForm.moa != null ? this.advancedFilterForm.moa : null;
            this.searchCriteria.status = this.advancedFilterForm.status != null ? this.advancedFilterForm.status : null;
            this.searchCriteria.purpose = this.advancedFilterForm.purpose != null ? this.advancedFilterForm.purpose : null;
            this.searchCriteria.isRegisterCert = this.advancedFilterForm.isRegisterCert != null ? this.advancedFilterForm.isRegisterCert : null;
            this.searchCriteria.productAI = this.advancedFilterForm.productAI != null ? this.advancedFilterForm.productAI : null;
            this.searchCriteria.productSource = this.advancedFilterForm.productSource != null ? this.advancedFilterForm.productSource : null;
            this.searchCriteria.productRecommendation = this.advancedFilterForm.productRecommendation != null ? this.advancedFilterForm.productRecommendation : null;
            this.searchCriteria.lrmp = this.advancedFilterForm.lrmp != null ? this.advancedFilterForm.lrmp : null;
            this.searchCriteria.referenceNumber = this.advancedFilterForm.referenceNumber != null ? this.advancedFilterForm.referenceNumber : null;
            this.searchCriteria.productLabel = this.advancedFilterForm.productLabel != null ? this.advancedFilterForm.productLabel : null;

            if (this.advancedFilterForm.dorStart != null && this.advancedFilterForm.dorEND != null) {
                this.searchCriteria.dorStart = this.advancedFilterForm.dorStart;
                this.searchCriteria.dorEND = this.advancedFilterForm.dorEND;
            }

            if (this.advancedFilterForm.expiredDateStart != null && this.advancedFilterForm.expiredDateEnd != null) {
                this.searchCriteria.expiredDateStart = this.advancedFilterForm.expiredDateStart;
                this.searchCriteria.expiredDateEnd = this.advancedFilterForm.expiredDateEnd;
            }

            if (this.advancedFilterForm.dossierSubmissionDateStart != null && this.advancedFilterForm.dossierSubmissionDateEnd != null) {
                this.searchCriteria.dossierSubmissionDateStart = this.advancedFilterForm.dossierSubmissionDateStart;
                this.searchCriteria.dossierSubmissionDateEnd = this.advancedFilterForm.dossierSubmissionDateEnd;
            }

            if (this.advancedFilterForm.approvalDateStart != null && this.advancedFilterForm.approvalDateEnd != null) {
                this.searchCriteria.approvalDateStart = this.advancedFilterForm.approvalDateStart;
                this.searchCriteria.approvalDateEnd = this.advancedFilterForm.approvalDateEnd;
            }

            this.getProductList(this.searchCriteria, false);
            this.$bvModal.hide('modal-filter-advanced');
            // this.advancedFilterForm.company = "";
            // this.advancedFilterForm.formulation = "";
            // this.advancedFilterForm.class = "";
            // this.advancedFilterForm.moa = "";
            // this.advancedFilterForm.status = "";
            // this.advancedFilterForm.brand = "";
            // this.advancedFilterForm.purpose = "";
            // this.advancedFilterForm.productAI = "";
            // this.advancedFilterForm.productSource = "";
            // this.advancedFilterForm.productRecommendation = "";
            // this.advancedFilterForm.lrmp = "";
            // this.advancedFilterForm.referenceNumber = "";
            // this.advancedFilterForm.dorStart = "";
            // this.advancedFilterForm.dorEND = "";
            // this.advancedFilterForm.expiredDateStart = "";
            // this.advancedFilterForm.expiredDateEnd = "";
            // this.advancedFilterForm.dossierSubmissionDateStart = "";
            // this.advancedFilterForm.dossierSubmissionDateEnd = "";
            // this.advancedFilterForm.isRegisterCert = "";
            // this.advancedFilterForm.approvalDateStart = "";
            // this.advancedFilterForm.approvalDateEnd = "";
            // this.advancedFilterForm.shelfLifeTime = "";
        },

        editStatus(user) {
            const data = {
                id: user.uuid,
                isActive: user.isActive,
            };

            this.updateProductStatus({ filter: this.searchCriteria, data });
        },

        getVariant(expiredDate) {
            if (!expiredDate) return 'secondary'; // fallback if date is missing

            const today = new Date();
            const expiry = new Date(expiredDate);
            const diffTime = expiry - today;
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (diffDays < 0) {
                return 'danger'; // expired
            } else if (diffDays <= 183) { // ~6 months
                return 'yellow'; // expiring within 6 months
            } else {
                return 'primary'; // valid
            }
        },
        toReportDetailsPage(id) {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_SEARCH)
            filter.selectedRecordId = id
            sessionHelper.storeSearch(SESSION.PRODUCT_SEARCH, filter)

            this.$router.push({
                name: 'Product-detail', // Name of the route
            });
        },
        toDetailsPage(id) {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_SEARCH)
            filter.selectedRecordId = id
            sessionHelper.storeSearch(SESSION.PRODUCT_SEARCH, filter)

            this.$router.push({
                name: 'Product-update', // Name of the route
            });
        },

    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                    v-if="isLoading == true">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right"
                                    style="float: left">
                                    <label class="d-inline-flex align-items-center">
                                        {{ $t("label.search") }}
                                        <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                                            class="form-control form-control-sm ml-2"
                                            @change="searchListing"></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="row d-flex justify-content-end">
                                    <div class="col-md-4 col-7">
                                        <multiselect v-model="isActive" deselect-label="" track-by="value" label="text"
                                            :placeholder="$t('module.status')" :options="statusDdl" :searchable="true"
                                            :allow-empty="false" v-on:input="searchListing" class="mb-2"></multiselect>
                                    </div>
                                    <div class="col-md-4 col-7">
                                        <div class="d-flex align-items-center">
                                            <!-- Multiselect -->
                                            <multiselect deselect-label="Can't remove this value" track-by="value"
                                                v-model="brandID" label="text" placeholder="Select one"
                                                :options="brandDdl" @input="filterBrand" :searchable="true"
                                                :allow-empty="true" class="w-100 mb-2"></multiselect>

                                            <!-- Cancel Icon -->
                                            <button v-if="brandID" class="btn btn-link p-0 ml-2" @click="clearBrand"
                                                title="Clear selection" style="font-size: 16px; line-height: 1;">
                                                <i class="mdi mdi-close-circle-outline text-danger"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-7">
                                        <router-link tag="a" :to="'/product/create'" v-if="createPermission == true"
                                            class="btn btn-primary w-md waves-effect waves-light mb-2 col-12">
                                            {{ $t('label.createX', [$t('module.product')]) }}
                                        </router-link>
                                    </div>
                                </div>
                                <div class="row d-flex justify-content-end">
                                    <div class="col-md-4">
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1">{{ $t('label.display')
                                                    }}</span>
                                            </div>
                                            <b-select id="displayModeSelect" v-model="displayMode.value"
                                                :options="displayModeOptions" class="form-control"
                                                @change="searchListing" />
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    {{ $t('label.pageSize') }}
                                                </span>
                                            </div>
                                            <b-select id="perPageSelect" v-model="perPage" :options="pageOptions"
                                                class="form-control" @change="onChangePerPage" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-7">
                                        <b-dropdown class="btn-group mb-2 col-12 px-0" variant="primary"
                                            v-if="exportPermission == true">
                                            <template #button-content>
                                                {{ $t('label.export') }}
                                                <i class="fa fa-upload pl-1"></i>
                                                <i class="mdi mdi-chevron-down ml-2"></i>
                                            </template>

                                            <b-dropdown-item href="javascript: void(0);" @click="exportAll(true)">
                                                {{ $t('label.export') }} {{ $t('label.all') }}
                                            </b-dropdown-item>
                                            <b-dropdown-item href="javascript: void(0);"
                                                @click="exportFilterShowModal()">
                                                {{ $t('label.export') }} {{ $t('label.filter') }}
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                    <div class="col-md-4 col-7">
                                        <button @click="advanceFilterShowModal"
                                            class="btn btn-warning w-md waves-effect waves-light mr-2 mb-2 col-12">
                                            <i class="fa fa-search pl-1"></i>
                                            {{ $t('label.filter') }}
                                        </button>

                                        <b-modal id="modal-filter" scrollable title="Filter Modal" title-class="font-18"
                                            :hide-header-close="true" @ok="exportFilter">
                                            <template #modal-header>
                                                <div class="d-flex justify-content-between w-100 align-items-center">
                                                    <h5 class="modal-title font-18">Filter Modal</h5>
                                                    <b-button size="sm" variant="outline-danger"
                                                        @click="exportFilterCloseModal">
                                                        <i class="mdi mdi-close"></i>
                                                    </b-button>
                                                </div>
                                            </template>
                                            <form @submit.prevent="exportFilter">
                                                <div class="row">
                                                    <div class="col-md-6" v-for="(value, index) in columns"
                                                        :key="index">
                                                        <b-form-checkbox v-model="filterOn" :value="value.key"
                                                            style="margin: 10px;" :id="'checkbox-' + value.key">
                                                            {{ value.label }}
                                                        </b-form-checkbox>
                                                    </div>
                                                </div>
                                                <div v-if="!$v.filterOn.required"
                                                    style="color: #ff3d60; font-size: 80%; float: right;">
                                                    <span v-if="!$v.filterOn.required">{{
                                                        $t("message.atLeastOneSelectedX", [$t("label.column")])
                                                        }}</span>
                                                </div>
                                            </form>
                                            <template #modal-footer>
                                                <b-button variant="secondary"
                                                    @click="exportFilterCloseModal()">Cancel</b-button>
                                                <b-button variant="primary" type="submit" @click="exportFilter()"
                                                    form="filter-form">Submit</b-button>
                                            </template>
                                        </b-modal>

                                        <b-modal id="modal-filter-advanced" scrollable title="Filter Modal"
                                            title-class="font-18" :hide-header-close="true" @ok="advancedFilter">
                                            <template #modal-header>
                                                <div class="d-flex justify-content-between w-100 align-items-center">
                                                    <h5 class="modal-title font-18">Advanced Filter Modal</h5>
                                                    <b-button size="sm" variant="outline-danger"
                                                        @click="advanceFilterCloseModal">
                                                        <i class="mdi mdi-close"></i>
                                                    </b-button>
                                                </div>
                                            </template>
                                            <form @submit.prevent="">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <b-form-group id="formulation" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('module.form')"
                                                            label-for="name">
                                                            <b-form-input id="company"
                                                                v-model.trim="advancedFilterForm.formulation"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group id="class" label-cols-sm="4" label-cols-lg="4"
                                                            :label="$t('module.class')" label-for="name">
                                                            <b-form-input id="class"
                                                                v-model.trim="advancedFilterForm.class"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group id="moa" label-cols-sm="4" label-cols-lg="4"
                                                            :label="$t('module.moa')" label-for="name">
                                                            <b-form-input id="moa"
                                                                v-model.trim="advancedFilterForm.moa"></b-form-input>
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-md-12">
                                                        <b-form-group id="" label-cols-sm="4" label-cols-lg="4"
                                                            :label="$t('label.status')" label-for="name">
                                                            <b-form-input id=""
                                                                v-model.trim="advancedFilterForm.status"></b-form-input>
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-md-12">
                                                        <b-form-group id="brand" label-cols-sm="4" label-cols-lg="4"
                                                            :label="$t('module.brand')" label-for="name">
                                                            <b-form-input id="brand"
                                                                v-model.trim="advancedFilterForm.brand"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group id="purpose" label-cols-sm="4" label-cols-lg="4"
                                                            :label="$t('module.purpose')" label-for="name">
                                                            <b-form-input id="purpose"
                                                                v-model.trim="advancedFilterForm.purpose"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group id="productAI" label-cols-sm="4" label-cols-lg="4"
                                                            :label="$t('module.productAI')" label-for="name">
                                                            <b-form-input id="productAI"
                                                                v-model.trim="advancedFilterForm.productAI"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group id="productSource" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('module.productSource')"
                                                            label-for="name">
                                                            <b-form-input id="productSource"
                                                                v-model.trim="advancedFilterForm.productSource"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group id="productRecommendation" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('module.recommendation')"
                                                            label-for="name">
                                                            <b-form-input id="productRecommendation"
                                                                v-model.trim="advancedFilterForm.productRecommendation"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group id="lrmp" label-cols-sm="4" label-cols-lg="4"
                                                            :label="$t('label.lrmp')" label-for="name">
                                                            <b-form-input id="lrmp"
                                                                v-model.trim="advancedFilterForm.lrmp"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group id="referenceNumber" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('label.XreferenceNumber', [])"
                                                            label-for="name">
                                                            <b-form-input id="referenceNumber"
                                                                v-model.trim="advancedFilterForm.referenceNumber"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group
                                                            label-cols-sm="4"
                                                            label-cols-lg="4"
                                                            :label="$t('module.productLabel')"
                                                            label-for="name"
                                                        >
                                                            <b-form-input
                                                                v-model.trim="advancedFilterForm.productLabel"
                                                            />
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="dorStart" label-cols-sm="4" label-cols-lg="4"
                                                            :label="$t('label.dorStart')" label-for="name">
                                                            <date-picker v-model="advancedFilterForm.dorStart"
                                                                type="date" format="YYYY-MM-DD" value-type="format"
                                                                placeholder="Select date"></date-picker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="dorEND" label-cols-sm="4" label-cols-lg="4"
                                                            :label="$t('label.dorEnd')" label-for="name">
                                                            <date-picker v-model="advancedFilterForm.dorEnd" type="date"
                                                                format="YYYY-MM-DD" value-type="format"
                                                                placeholder="Select date"></date-picker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="expiredDateStart" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('label.doeStart')"
                                                            label-for="name">
                                                            <date-picker v-model="advancedFilterForm.expiredDateStart"
                                                                type="date" format="YYYY-MM-DD" value-type="format"
                                                                placeholder="Select date"></date-picker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="expiredDateEnd" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('label.doeEnd')"
                                                            label-for="name">
                                                            <date-picker v-model="advancedFilterForm.expiredDateEnd"
                                                                type="date" format="YYYY-MM-DD" value-type="format"
                                                                placeholder="Select date"></date-picker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="dossierSubmissionDateStart" label-cols-sm="4"
                                                            label-cols-lg="4"
                                                            :label="$t('label.dorSubmissionDateStart')"
                                                            label-for="name">
                                                            <date-picker
                                                                v-model="advancedFilterForm.dossierSubmissionDateStart"
                                                                type="date" format="YYYY-MM-DD" value-type="format"
                                                                placeholder="Select date"></date-picker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="dossierSubmissionDateEnd" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('label.dorSubmissionDateEnd')"
                                                            label-for="name">
                                                            <date-picker
                                                                v-model="advancedFilterForm.dossierSubmissionDateEnd"
                                                                type="date" format="YYYY-MM-DD" value-type="format"
                                                                placeholder="Select date"></date-picker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="approvalDateStart" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('label.approvalDateStart')"
                                                            label-for="name">
                                                            <date-picker v-model="advancedFilterForm.approvalDateStart"
                                                                type="date" format="YYYY-MM-DD" value-type="format"
                                                                placeholder="Select date"></date-picker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="approvalDateEnd" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('label.approvalDateEnd')"
                                                            label-for="name">
                                                            <date-picker v-model="advancedFilterForm.approvalDateEnd"
                                                                type="date" format="YYYY-MM-DD" value-type="format"
                                                                placeholder="Select date"></date-picker>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="shelfLifeTime" label-cols-sm="4"
                                                            label-cols-lg="4" :label="$t('label.shelfLifeTimeYear')"
                                                            label-for="shelfLifeTime">
                                                            <multiselect v-model="advancedFilterForm.shelfLifeTime"
                                                                track-by="code" label="name" placeholder="Select one"
                                                                :options="timeDdl" :searchable="true"
                                                                :allow-empty="true">
                                                            </multiselect>
                                                        </b-form-group>
                                                    </div>
                                                    <!-- <div class="col-md-6">
                                                        <b-form-group style="padding-right: 10px;">
                                                            <b-form-checkbox id="isRegisterCert"
                                                                v-model="advancedFilterForm.isRegisterCert" :value="true"
                                                                :unchecked-value="false" switch>
                                                                {{ $t('label.isRegisterCert') }}
                                                            </b-form-checkbox>
                                                        </b-form-group>
                                                    </div> -->
                                                </div>
                                            </form>
                                            <template #modal-footer>
                                                <b-button variant="secondary"
                                                    @click="advanceFilterCloseModal">Cancel</b-button>
                                                <b-button variant="primary" type="submit" @click="advancedFilter()"
                                                    form="filter-form">Submit</b-button>
                                            </template>
                                        </b-modal>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ProductTableClassic v-if="displayMode.value == 1" :tableRows="tableRows" :perPage="perPage"
                            :updateStatusPermission="updateStatusPermission" :currentUser="currentUser"
                            :readPermission="readPermission" :updatePermission="updatePermission"
                            @editStatus="editStatus" @toReportDetailsPage="toReportDetailsPage"
                            @toDetailsPage="toDetailsPage" />

                        <ProductGridTable v-if="displayMode.value == 2" :tableRows="tableRows"
                            :currentUser="currentUser" :updateStatusPermission="updateStatusPermission"
                            :readPermission="readPermission" :updatePermission="updatePermission"
                            @editStatus="editStatus" @toReportDetailsPage="toReportDetailsPage"
                            @toDetailsPage="toDetailsPage" />


                        <div class="table-responsive mb-0" v-if="displayMode.value == 3">
                            <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                                v-if="readPermission == true">
                                <template #cell(isActive)="data">
                                    <b-form-checkbox @change="editStatus(tableRows[data.index])"
                                        :disabled="updateStatusPermission == false"
                                        v-model="tableRows[data.index].isActive" switch class="mb-1">
                                    </b-form-checkbox>
                                </template>

                                <template #cell(brand)="data">
                                    <span>{{ tableRows[data.index].brand.name }}</span>
                                </template>

                                <template #cell(expiredDate)="data">
                                    <b-badge pill :variant="getVariant(tableRows[data.index].expiredDate)">
                                        {{ tableRows[data.index].expiredDate }}
                                    </b-badge>
                                </template>

                                <template #cell(status)="data">
                                    <b-badge pill variant="primary"
                                        v-if="tableRows[data.index].status.uuid != '58380ab4-67a4-40ee-9860-7d5ba78f965f'">
                                        {{ tableRows[data.index].status.name }}
                                    </b-badge>
                                    <b-badge pill variant="warning" v-else>
                                        {{ tableRows[data.index].status.name }}
                                    </b-badge>
                                </template>

                                <template #cell(productAI)="data">
                                    <span>{{data.item.productAI.map(ai =>
                                        ai.rnd_active_ingredient.name).join('+')}}</span>
                                </template>


                                <template #cell(action)="data">
                                    <a style="padding-right: 10px;" href="javascript:void(0);"
                                        :class="currentUser == tableRows[data.index].email ? 'disabled text-warning' : 'text-primary'"
                                        @click="toReportDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover.top
                                        v-if="readPermission == true && updatePermission == true" title="Detail">
                                        <i class="mdi mdi-file-document-outline font-size-18"></i>
                                    </a>

                                    <a href="javascript:void(0);"
                                        :class="currentUser == tableRows[data.index].email ? 'disabled text-warning' : 'text-primary'"
                                        @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover.top
                                        v-if="readPermission == true && updatePermission == true" title="Edit">
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>

                                    <a href="javascript:void(0);"
                                        :class="currentUser == tableRows[data.index].email ? 'disabled text-warning' : 'text-primary'"
                                        @click="toDetailsPage(tableRows[data.index].uuid)" style="margin-left: 5px;"
                                        v-b-tooltip.hover.top v-if="readPermission == true && updatePermission != true"
                                        title="Read">
                                        <i class="mdi mdi-file-search-outline font-size-18"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div style="text-align: center;" v-else>
                                {{ $t('message.noPermissionMessage') }}
                            </div>
                        </div>
                        <div class="row" v-if="readPermission == true">
                            <div class="col">
                                <div class="d-flex justify-content-between align-items-center">
                                    <!-- ✅ Page size selector -->
                                    <div class="d-flex align-items-center">
                                        <span class="mr-2">{{ $t('label.pageSize') || 'Page size' }}</span>
                                        <b-select id="perPageSelect" v-model="perPage" :options="pageOptions"
                                            class="form-control form-control-sm w-auto" @change="onChangePerPage" />
                                    </div>

                                    <!-- Existing pagination -->
                                    <div class="dataTables_paginate paging_simple_numbers">
                                        <ul class="pagination pagination-rounded mb-0">
                                            <b-pagination v-model="currentPage" :total-rows="totalPage"
                                                :per-page="perPage" @change="pageNavigation" />
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
a.disabled {
    pointer-events: none;
    cursor: default;
}

.badge-yellow {
    background-color: goldenrod;
    color: #fff;
}
</style>